module.exports = __webpack_public_path__ + "img/img3.d7e7bd81.jpg";